// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3L1xp","bigColWidth":"Table_bigColWidth__2UHP4","biggerColWidth":"Table_biggerColWidth__NgcKc","row":"Table_row__3WCSp","col":"Table_col__1Eq7V"};